import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGlobe } from 'react-icons/fa';

/** Ethosboard / Infylearn contact details */
export const ETHOSBOARD_CONTACT = {
  salesEmail: 'engage@infylearn.net',
  phone: '+971 551926066',
  hqLabel: 'HQ: UAE',
  hqAddress: [
    'Shams Business Center, Sharjah Media City Free Zone',
    'Al Messaned, Sharjah, UAE',
  ],
  indiaLabel: 'Office: India',
  indiaAddress: [
    'Awfis, 1st Floor, Parinee Cresenzo,',
    'C-30, G Block, Bandra Kurla Complex,',
    'Bandra East BKC,',
    'Mumbai - 400051',
  ],
  website: 'https://ethosboard.com/',
  contactPage: '/enquiry',
};

export const ETHOSBOARD_OFFICES = [
  {
    region: 'UAE (HQ)',
    company: 'Ethosboard',
    lines: ETHOSBOARD_CONTACT.hqAddress,
  },
  {
    region: 'India',
    company: 'Ethosboard',
    lines: ETHOSBOARD_CONTACT.indiaAddress,
  },
];

export const ETHOSBOARD_CONTACT_CARDS = [
  {
    icon: FaEnvelope,
    title: 'Email',
    lines: [ETHOSBOARD_CONTACT.salesEmail],
    href: `mailto:${ETHOSBOARD_CONTACT.salesEmail}`,
  },
  {
    icon: FaPhone,
    title: 'Phone',
    lines: [ETHOSBOARD_CONTACT.phone],
    href: `tel:${ETHOSBOARD_CONTACT.phone.replace(/\s/g, '')}`,
  },
  {
    icon: FaMapMarkerAlt,
    title: ETHOSBOARD_CONTACT.hqLabel,
    lines: ETHOSBOARD_CONTACT.hqAddress,
  },
  {
    icon: FaGlobe,
    title: ETHOSBOARD_CONTACT.indiaLabel,
    lines: ETHOSBOARD_CONTACT.indiaAddress,
  },
];

export const ETHOSBOARD_AWARDS = [
  {
    value: '10+',
    title: 'Years of Innovation',
    description: 'Building modern learning experiences for enterprise teams.',
  },
  {
    value: '10+',
    title: 'Industry Recognitions',
    description: 'Recognized for excellence in learning and talent development.',
  },
];

export const ETHOSBOARD_TESTIMONIALS = [];

export const CATEGORY_DATA = {
  all: { name: 'All Courses', icon: '📚' },
  1: { name: 'Business Management', icon: '💼' },
  2: { name: 'Technology and Programming', icon: '💻' },
  3: { name: 'Personal Development', icon: '🌱' },
  4: { name: 'Workplace Skills', icon: '🛠️' },
};

export const getCategoryLabel = (categoryId) =>
  CATEGORY_DATA[categoryId]?.name || CATEGORY_DATA[Number(categoryId)]?.name || 'Uncategorized';
